// extracted by mini-css-extract-plugin
export var grid = "_2s-0";
export var span1 = "_2s-2";
export var span10 = "_2s-b";
export var span10L = "_2s-z";
export var span10M = "_2s-n";
export var span10Xl = "_2s-1b";
export var span11 = "_2s-c";
export var span11L = "_2s-10";
export var span11M = "_2s-o";
export var span11Xl = "_2s-1c";
export var span12 = "_2s-d";
export var span12L = "_2s-11";
export var span12M = "_2s-p";
export var span12Xl = "_2s-1d";
export var span1L = "_2s-q";
export var span1M = "_2s-e";
export var span1Xl = "_2s-12";
export var span2 = "_2s-3";
export var span2L = "_2s-r";
export var span2M = "_2s-f";
export var span2Xl = "_2s-13";
export var span3 = "_2s-4";
export var span3L = "_2s-s";
export var span3M = "_2s-g";
export var span3Xl = "_2s-14";
export var span4 = "_2s-5";
export var span4L = "_2s-t";
export var span4M = "_2s-h";
export var span4Xl = "_2s-15";
export var span5 = "_2s-6";
export var span5L = "_2s-u";
export var span5M = "_2s-i";
export var span5Xl = "_2s-16";
export var span6 = "_2s-7";
export var span6L = "_2s-v";
export var span6M = "_2s-j";
export var span6Xl = "_2s-17";
export var span7 = "_2s-8";
export var span7L = "_2s-w";
export var span7M = "_2s-k";
export var span7Xl = "_2s-18";
export var span8 = "_2s-9";
export var span8L = "_2s-x";
export var span8M = "_2s-l";
export var span8Xl = "_2s-19";
export var span9 = "_2s-a";
export var span9L = "_2s-y";
export var span9M = "_2s-m";
export var span9Xl = "_2s-1a";
export var stretch = "_2s-1";